export interface Plan {
  id: string
  name: PlanName
  displayName: string
}

export enum PlanName {
  Starter = 'starter',
  FleetEssentials = 'fleet_essentials',
  FleetPlus = 'fleet_plus',
}
